grw-app {
  display: block;
  position: relative;
  width: var(--app-width);
  height: var(--app-height);
  overflow: hidden;
  max-width: 100dvw;
  max-height: 100dvh;
}

.grw-app-container {
  position: relative;
  background-color: var(--color-background);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.grw-languages-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 16px 16px 0px 0px;
}

.grw-header-container,
.grw-large-view-header-container {
  height: calc(var(--header-height) + var(--header-with-offline) + var(--header-with-languages));
  .grw-arrow-back-container {
    display: flex;
    align-items: center;
    height: 100%;
    margin: 0px 16px;
    .grw-arrow-back-icon {
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      color: var(--color-on-surface);
      border: none;
      background-color: var(--color-background);
      border-radius: var(--border-radius, 50%);
      height: 48px;
      width: 48px;
      padding: 0px;
      text-align: left;
    }
  }
}

.grw-handle-search-filters-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0px 16px;
  height: 64px;

  .grw-handle-search-container {
    width: calc(50% + 48px);
    max-width: 220px;
  }
  .grw-handle-filters-container {
    margin-left: 16px;
  }
}

.grw-header-detail {
  min-height: 64px;
  height: 64px;
}

.grw-large-view-header-container {
  .grw-handle-search-filters-container {
    justify-content: flex-start;
  }
}

.grw-init-loader-container,
.grw-loader-container,
.grw-large-view-loader-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: var(--color-background);
}

.grw-content-container {
  position: relative;
  display: flex;
}

.grw-content-treks {
  height: calc(100% - var(--header-height) - var(--header-with-languages) - var(--header-with-offline));
}

.grw-content-trek {
  height: calc(100% - var(--header-height) - var(--header-with-languages));
}

.grw-large-view-app-list-container,
.grw-large-view-app-trek-detail-container,
.grw-large-view-app-touristic-content-detail-container,
.grw-large-view-app-touristic-event-detail-container,
.grw-large-view-app-outdoor-site-detail-container,
.grw-large-view-app-outdoor-course-detail-container,
.grw-large-view-app-list-container,
.grw-large-view-app-trek-detail-container {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  height: 100%;
}

.grw-app-map-container,
.grw-large-view-app-map-container {
  width: 100%;
  height: 100%;
}

.grw-map-visibility-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 24px;
  z-index: 4;
  pointer-events: none;
}

.grw-init-loader-container,
.grw-loader-container {
  width: 100%;
}

.grw-app-list-container,
.grw-app-trek-detail-container,
.grw-app-touristic-content-detail-container,
.grw-app-touristic-event-detail-container,
.grw-app-outdoor-site-detail-container,
.grw-app-outdoor-course-detail-container {
  width: 100%;
}

grw-treks-list,
grw-touristic-contents-list,
grw-touristic-events-list,
grw-outdoor-sites-list {
  max-height: calc(100vh - var(--header-height));
}

grw-trek-detail {
  position: relative;
  max-height: 100%;
}

grw-touristic-content-detail,
grw-touristic-event-detail,
grw-outdoor-site-detail {
  position: relative;
  max-height: 100%;
}

.grw-app-map-container {
  width: 100%;
  position: absolute;
}

.grw-large-view-loader-container {
  position: relative;
  width: 50%;
}

.grw-large-view-app-list-container,
.grw-large-view-app-trek-detail-container,
.grw-large-view-app-touristic-content-detail-container,
.grw-large-view-app-touristic-event-detail-container,
.grw-large-view-app-outdoor-site-detail-container,
.grw-large-view-app-outdoor-course-detail-container {
  width: 50%;
}

.grw-large-view-app-map-container {
  position: relative;
  width: 50%;
}

.grw-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  font-family: var(--font-family);
  font-size: 16px;
  grw-common-button {
    margin-top: 16px;
  }
}

.grw-offline-container {
  display: flex;
  align-items: center;
  margin: 0px 0px 0px 16px;
  height: 48px;
  .grw-offline-label {
    display: flex;
  }
  grw-switch {
    margin-top: -10px;
  }
}
